import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { BrowserRouter } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'

// dayjs imports
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat' // localized date formatting
import 'dayjs/locale/ru' // Russian locale
import 'dayjs/locale/uk' // Ukrainian locale

// i18n localization config
import './i18n'

// reducers
import streamerCards from './components/streamer-cards/streamerCardsReducer'
import authorization from './components/top-panel/authorized-controls/authorizationReducer'
import topPanel from './components/top-panel/topPanelReducer'
import signUp from './components/top-panel/unauthorized-controls/sign-up/signUpReducer'
import subscribers from './components/cabinet/subscribers/subscribersReducer'
import myEvents from './components/cabinet/my-events/myEventsReducer'
import paidEvents from './components/cabinet/paid-events/paidEventsReducer'
import shop from './components/cabinet/shop/shopReducer'
import creditCards from './components/cabinet/credit-cards/creditCardsReducer'
import interestingEvents from './components/cabinet/interesting-events/interestingEventsReducer'

// actions
import { fetchStreamerCards } from './components/streamer-cards/streamerCardsActions'
import { checkLocalStorageLogin } from './components/top-panel/authorized-controls/authorizationActions'

import App from './components/app/App'
import './index.css'

// enabling dayjs plugin
dayjs.extend(LocalizedFormat)

const rootReducer = combineReducers({
  streamerCards,
  authorization,
  topPanel,
  signUp,
  subscribers,
  myEvents,
  paidEvents,
  shop,
  creditCards,
  interestingEvents
})

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware))

store.dispatch(checkLocalStorageLogin())
store.dispatch(fetchStreamerCards())

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      {/* Suspense is here due to the translation res being loaded dynamically
            React needs to have a fallback Component, while they'll are loading */}
      <Suspense fallback={<div>Loading...</div>}>
        <App />
      </Suspense>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
